<app-access-item [small]="true">
  <app-access-item-header>
    <div>Font Family</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-context-menu
      [options]="{ width: '260px', noSpacing: true }"
      [position]="'right'"
      #menu
      name="font-selection-menu"
    >
      <button
        appButton
        name="font-selection-menu"
        location="theme-font-family-item"
        [hasIcon]="true"
        color="simple"
        height="0"
        spacing="1"
        weight="bold"
        contextButton
      >
        <span>{{ fontFamilyDisplay() }}</span>
        <app-svg src="/assets/icons/24/chevron-down.svg" size="-1"></app-svg>
      </button>
      <div contextContent>
        <app-font-selection-menu [currentFont]="fontFamily()" (onSelected)="fontFamilyChange.emit($event)">
        </app-font-selection-menu>
      </div>
    </app-context-menu>
  </app-access-item-cta>
</app-access-item>
